<template>
  <div class="schedule schedule--cancel background-gray min-height-inherit">
    <section class="py-4 py-md-5">
      <div class="container container--lg">
        <div class="confirmation-header">
          <div class="confirmation-header__icon">
            <i class="material-icons">check</i>
          </div>
          <h1 class="title title--l text-primary weight-bolder">
            {{ current_user.user.firstname }}, tu hora de mantención ha sido
            anulada exitosamente.
          </h1>
        </div>

        <div class="confirmation box">
          <div class="confirmation__summary text">
            <p>
              Puedes revisar en tu correo el comprobante de la anulación de
              reserva.
            </p>
          </div>
          <div class="confirmation__contact row">
            <div class="col-md-3">
              <p class="text text--small weight-bolder text-uppercase">
                Datos de contacto para consultas
              </p>
            </div>
            <div class="col-md-4">
              <p class="text text--small">
                <span class="weight-bolder">Teléfono Call Center</span>
                <br /><a :href="`tel:6005700007`"
                  ><i class="material-icons">phone</i>600 570 0007</a
                >
              </p>
            </div>
          </div>
        </div>
        <div class="confirmation__actions text-center mt-4">
          <router-link :to="{ name: 'home' }" class="button button--primary"
            ><span class="button__text">Volver al inicio</span></router-link
          >
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'CancelConfirmation',
  computed: {
    ...mapState(['current_user']),
  },
  mounted() {
    this.$store.dispatch('setCurrentStep', 0);
  },
};
</script>
